// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__o09pW","productName":"Table_productName__1Yz3U"};